export const INDIAN_CITIES = [
  'Agartala','Agra','Ahmedabad','Aizawl','Ajmer','Aligarh','Allahabad','Alwar',
  'Amaravati','Ambala','Amritsar','Anantapur','Asansol','Aurangabad','Bareilly',
  'Belagavi','Ballari','Bengaluru','Bhatinda','Bhilai','Bhiwandi','Bhopal',
  'Bhubaneswar','Bikaner','Bilaspur','Bokaro','Brahmapur','Chandigarh','Chennai',
  'Coimbatore','Cuttack','Darbhanga','Dehradun','Delhi',"Deoria",'Dhanbad','Dibrugarh',
  'Dimapur','Durgapur','Erode','Ernakulam','Faridabad','Firozabad','Gandhidham',
  'Gandhinagar','Gaya','Ghaziabad','Gorakhpur','Gulbarga','Guntur','Gurgaon',
  'Guwahati','Gwalior','Hisar','Hosur','Howrah','Hubballi','Hyderabad','Imphal',
  'Indore','Itanagar','Jabalpur','Jaipur','Jalandhar','Jammu','Jamnagar',
  'Jamshedpur','Jhansi','Jodhpur','Jorhat','Kadapa','Kakinada','Kalaburagi',
  'Kalyan-Dombivli','Kanchipuram','Kanpur','Karimnagar','Karnal','Kavaratti',
  'Kharagpur','Khanna','Kohima','Kolar','Kochi','Kolhapur','Kolkata','Kollam',
  'Korba','Kota','Kottayam','Kozhikode','Kurnool','Latur','Leh','Lucknow',
  'Ludhiana','Madurai','Maheshtala','Malappuram','Mangalore','Mathura','Meerut',
  'Moradabad','Mumbai','Muzaffarpur','Mysuru','Nagpur','Nanded','Nashik',
  'Nellore','Noida','Ongole','Panaji','Panchkula','Pathankot','Patiala',
  'Patna','Porbandar','Puducherry','Port Blair','Prayagraj','Pune','Puri',
  'Raebareli','Raichur','Raipur','Rajahmundry','Rajkot','Ranchi','Ratlam',
  'Rewa','Rohtak','Rourkela','Sagar','Salem','Sambalpur','Sangli','Satara',
  'Secunderabad','Shillong','Shimla','Shivamogga','Sikar','Siliguri','Solapur',
  'Sonipat','Srinagar','Surat','Thane','Thiruvananthapuram','Thoothukudi',
  'Thrissur','Tiruchirappalli','Tirunelveli','Tirupati','Tiruppur','Tiruvannamalai',
  'Udaipur','Udhampur','Ujjain','Ulhasnagar','Vadodara','Varanasi','Vasai-Virar',
  'Vellore','Vijayawada','Villupuram','Visakhapatnam','Warangal','Yamunanagar'
];
